import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { SideNav } from './src/components/Layout/SideNav';
import { MobileNav } from './src/components/Layout/MobileNav';
import { TopBar } from './src/components/Layout/TopBar';
import { Dashboard } from './src/pages/Dashboard';
import { LeadsList } from './src/pages/LeadsList';
import { LeadDetail } from './src/pages/LeadDetail';
import { Cadencias } from './src/pages/Cadencias';
import { Qa } from './src/pages/Qa';
import { Reportes } from './src/pages/Reportes';
import { Config } from './src/pages/Config';
import { Calendario } from './src/pages/Calendario';
import { AuthProvider } from './src/context/AuthContext';
import { DataStoreProvider } from './src/context/DataStoreContext';
import { RequireAuth } from './src/components/auth/RequireAuth';
import { Login } from './src/pages/Login';
const Placeholder = ({
  title
}: {
  title: string;
}) => <div className="p-8 flex items-center justify-center h-full text-growthly-muted" data-id="element-0">
    <div className="text-center" data-id="element-1">
      <h2 className="text-[22px] font-semibold text-growthly-text mb-2" data-id="element-2">
        {title}
      </h2>
      <p data-id="element-3">Página en construcción</p>
    </div>
  </div>;
function ProtectedLayout() {
  return <div className="min-h-screen bg-growthly-bg flex flex-col md:flex-row" data-id="element-4">
      <SideNav data-id="element-5" />
      <TopBar data-id="element-6" />
      <main className="flex-1 md:ml-[260px] w-full min-h-screen relative" data-id="element-7">
        <Outlet data-id="element-8" />
      </main>
      <MobileNav data-id="element-9" />
    </div>;
}
function LegacyLeadRedirect() {
  const loc = useLocation();
  const id = loc.pathname.split('/').pop();
  return <Navigate to={`/app/leads/${id}`} replace data-id="element-10" />;
}
export function App() {
  return <AuthProvider data-id="element-11">
      <DataStoreProvider data-id="element-12">
        <Router data-id="element-13">
          <Routes data-id="element-14">
            {/* Public */}
            <Route path="/login" element={<Login data-id="element-16" />} data-id="element-15" />

            {/* Protected /app/* */}
            <Route element={<RequireAuth data-id="element-18">
                  <ProtectedLayout data-id="element-19" />
                </RequireAuth>} data-id="element-17">
              <Route path="/app/dashboard" element={<Dashboard data-id="element-21" />} data-id="element-20" />
              <Route path="/app/leads" element={<LeadsList data-id="element-23" />} data-id="element-22" />
              <Route path="/app/leads/:id" element={<LeadDetail data-id="element-25" />} data-id="element-24" />
              <Route path="/app/enriquecimiento" element={<Placeholder title="Enriquecimiento" data-id="element-27" />} data-id="element-26" />
              <Route path="/app/calendario" element={<Calendario data-id="element-29" />} data-id="element-28" />
              <Route path="/app/cadencias" element={<Cadencias data-id="element-31" />} data-id="element-30" />
              <Route path="/app/campanas" element={<Placeholder title="Campañas WA/DM" data-id="element-33" />} data-id="element-32" />
              <Route path="/app/qa" element={<Qa data-id="element-35" />} data-id="element-34" />
              <Route path="/app/reportes" element={<Reportes data-id="element-37" />} data-id="element-36" />
              <Route path="/app/config" element={<Config data-id="element-39" />} data-id="element-38" />
            </Route>

            {/* Legacy redirects */}
            <Route path="/" element={<Navigate to="/app/dashboard" replace data-id="element-41" />} data-id="element-40" />
            <Route path="/leads" element={<Navigate to="/app/leads" replace data-id="element-43" />} data-id="element-42" />
            <Route path="/leads/:id" element={<LegacyLeadRedirect data-id="element-45" />} data-id="element-44" />
            <Route path="/calendario" element={<Navigate to="/app/calendario" replace data-id="element-47" />} data-id="element-46" />
            <Route path="/cadencias" element={<Navigate to="/app/cadencias" replace data-id="element-49" />} data-id="element-48" />
            <Route path="/qa" element={<Navigate to="/app/qa" replace data-id="element-51" />} data-id="element-50" />
            <Route path="/reportes" element={<Navigate to="/app/reportes" replace data-id="element-53" />} data-id="element-52" />
            <Route path="/config" element={<Navigate to="/app/config" replace data-id="element-55" />} data-id="element-54" />
            <Route path="*" element={<Navigate to="/login" replace data-id="element-57" />} data-id="element-56" />
          </Routes>
        </Router>
      </DataStoreProvider>
    </AuthProvider>;
}